import { displayName, type Slug } from "../../lib/candidates.ts";
import { candidateImage } from "../assets.ts";

let panel: HTMLElement | null = null;

export function closeChat(): void {
  panel?.remove();
  panel = null;
}

// Opens the candidate's chat panel. The AI chat — grounded in each candidate's
// published material — isn't live yet, so we show a "próximamente" notice
// rather than any simulated answers. (Real corpus provider swaps in at 4.5.R.)
export function openChat(slug: Slug): void {
  closeChat();

  const el = document.createElement("div");
  el.className =
    "fixed right-4 top-4 bottom-4 z-20 flex w-[360px] max-w-[90vw] flex-col rounded-2xl border-2 border-black bg-white shadow-xl";

  const header = document.createElement("div");
  header.className = "flex items-center gap-3 border-b-2 border-black p-3";
  const img = document.createElement("img");
  img.src = candidateImage(slug);
  img.alt = "";
  img.className = "h-12 w-12 object-contain";
  const name = document.createElement("div");
  name.className = "font-bold";
  name.textContent = displayName(slug);
  const close = document.createElement("button");
  close.className =
    "ml-auto h-7 w-7 rounded-full border-2 border-black text-lg leading-none";
  close.textContent = "×";
  close.addEventListener("click", closeChat);
  header.append(img, name, close);

  // "Coming soon" notice in place of the (not-yet-live) conversation.
  const body = document.createElement("div");
  body.className =
    "flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center";
  const badge = document.createElement("div");
  badge.className = "text-5xl";
  badge.textContent = "🚧";
  const msg = document.createElement("p");
  msg.className = "text-lg font-bold";
  msg.textContent =
    `El chat con ${displayName(slug)} estará disponible próximamente.`;
  const sub = document.createElement("p");
  sub.className = "text-sm opacity-60";
  sub.textContent =
    "Pronto podrás conversar con una versión IA basada únicamente en su " +
    "material publicado.";
  body.append(badge, msg, sub);

  // Disabled input bar — the chat UI is built, just not active yet.
  const bar = document.createElement("div");
  bar.className = "flex gap-2 border-t-2 border-black/30 p-3";
  const input = document.createElement("input");
  input.className =
    "flex-1 rounded-lg border-2 border-black/30 px-2 py-1 text-black/40";
  input.placeholder = "Disponible próximamente…";
  input.disabled = true;
  const send = document.createElement("button");
  send.className =
    "rounded-lg border-2 border-black/30 px-3 font-bold text-black/30";
  send.textContent = "→";
  send.disabled = true;
  bar.append(input, send);

  el.append(header, body, bar);
  document.body.appendChild(el);
  panel = el;
}
